(function () {
  var KEYS = {
    visits: 'mg_club_visits',
    joined: 'mg_club_joined',
    dismissed: 'mg_club_dismissed_until',
  };

  function read(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function visits() {
    var n = parseInt(read(KEYS.visits) || '0', 10) + 1;
    write(KEYS.visits, String(n));
    return n;
  }

  function dismissedActive() {
    var until = parseInt(read(KEYS.dismissed) || '0', 10);
    return until > Date.now();
  }

  function markJoined() {
    write(KEYS.joined, '1');
  }

  function markDismissed(days) {
    write(KEYS.dismissed, String(Date.now() + days * 86400000));
  }

  function shouldOpenModal(cfg) {
    if (read(KEYS.joined) === '1') return false;
    if (dismissedActive()) return false;
    if (document.querySelector('[data-mg-retention-success]')) {
      markJoined();
      return false;
    }
    var v = visits();
    return v >= (cfg.minVisits || 2);
  }

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initModal() {
    var modal = document.getElementById('mg-retention-modal');
    if (!modal) return;

    var cfg = {
      minVisits: parseInt(modal.dataset.minVisits || '2', 10),
      delayMs: parseInt(modal.dataset.delayMs || '12000', 10),
    };

    var backdrop = modal.querySelector('[data-mg-retention-close]');
    var closeBtn = modal.querySelector('.mg-retention-modal__close');

    function dismiss() {
      markDismissed(parseInt(modal.dataset.dismissDays || '7', 10));
      closeModal(modal);
    }

    if (backdrop) backdrop.addEventListener('click', dismiss);
    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) dismiss();
    });

    if (document.querySelector('[data-mg-retention-success]')) {
      markJoined();
      return;
    }

    if (!shouldOpenModal(cfg)) return;

    window.setTimeout(function () {
      if (!dismissedActive() && read(KEYS.joined) !== '1') openModal(modal);
    }, cfg.delayMs);
  }

  function initForms() {
    document.querySelectorAll('[data-mg-retention-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        write('mg_club_pending', '1');
      });
    });

    if (read('mg_club_pending') === '1' && document.querySelector('[data-mg-retention-success]')) {
      markJoined();
      write('mg_club_pending', '0');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initModal();
    initForms();
  });
})();